import FilterOperator from '@/constants/forms/FilterOperator';

const OperatorLabelMap: Record<FilterOperator, string> = {
  [FilterOperator.IS]: 'OPERATOR_IS',
  [FilterOperator.IS_NOT]: 'OPERATOR_IS_NOT',
  [FilterOperator.CONTAINS]: 'OPERATOR_CONTAINS',
  [FilterOperator.NOT_CONTAINS]: 'OPERATOR_NOT_CONTAINS',
  [FilterOperator.LESS_THAN]: 'OPERATOR_LESS_THAN',
  [FilterOperator.GREATER_THAN]: 'OPERATOR_GREATER_THAN',
  [FilterOperator.ANY]: 'OPERATOR_ANY',
  [FilterOperator.ALL]: 'OPERATOR_ALL',
  [FilterOperator.IS_NULL]: 'OPERATOR_IS_NULL',
  [FilterOperator.IS_NOT_NULL]: 'OPERATOR_IS_NOT_NULL',
  [FilterOperator.NONE_OF]: 'OPERATOR_NONE_OF',
  [FilterOperator.BETWEEN]: 'OPERATOR_BETWEEN',
};

export default OperatorLabelMap;
